module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/slide01-1a22af8a970a4efaf52adc0875810704.png";